import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import ImageUpload from "../../components/common/ImageUpload";
import { createLandingCard, updateLandingCard } from "../../api/landing";

const CreateLandingCardModal = ({ show, handleClose, onLandingCardCreated,cardDetail,cardId }) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    title ="",
      subtitle="",
      type="",
      content="",
      featured_image = "",
      is_active=true,
  } = cardDetail;
  const [formData, setFormData] = useState({
      title,
      subtitle,
      type,
      content,
      featured_image,
      is_active
  });

  useEffect(() => {
    setFormData({
      title,
      subtitle,
      type,
      content,
      featured_image,
      is_active
    });
  }, [cardDetail, content, featured_image, is_active, subtitle, title, type]);

  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const payload = {
      title : formData?.title,
      subtitle: formData?.subtitle,
      type: formData?.type,
      content: formData?.content,
      featured_image: formData?.featured_image,
      is_active:formData?.is_active
    };

    try {
      // Adjust the endpoint as necessary if your POST endpoint differs.
      const { data } = cardId ? await updateLandingCard(cardId,payload) : await createLandingCard(payload);
      onLandingCardCreated(data.data);
      // Reset fields and close modal after successful creation
      handleClose();
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title> {cardId ? 'Update' : 'Create New'} Landing Card</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formLandingCardTitle" className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              value={formData?.title}
              onChange={(e) => handleInputChange('title',e.target.value)}
              placeholder="Enter title"
              required
            />
          </Form.Group>
          <Form.Group controlId="formLandingCardSubtitle" className="mb-3">
            <Form.Label>Subtitle</Form.Label>
            <Form.Control
              type="text"
              value={formData?.subtitle}
              onChange={(e) => handleInputChange('subtitle',e.target.value)}
              placeholder="Enter subtitle"
              required
            />
          </Form.Group>
          <Form.Group controlId="formLandingCardType" className="mb-3">
            <Form.Label>Type</Form.Label>
            <Form.Control
              type="text"
              value={formData?.type}
              onChange={(e) => handleInputChange('type',e.target.value)}
              placeholder="Enter type (e.g., beast_mode, plan_mode)"
              required
            />
          </Form.Group>
          <Form.Group controlId="formLandingCardContent" className="mb-3">
            <Form.Label>Content</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData?.content}
              onChange={(e) => handleInputChange('content',e.target.value)}
              placeholder="Enter content"
              required
            />
          </Form.Group>
          <Form.Group controlId="formLandingCardContent" className="mb-3">
            <div className="d-flex align-items-center">
              <Form.Label className="mb-0 me-2">Status</Form.Label>
              <Form.Switch 
                id="custom-switch"
                onChange={(e) => handleInputChange('is_active', e.target.checked)}
                checked={formData?.is_active}
                className="mb-0"
              />
            </div>
          </Form.Group>
          {formData?.featured_image && <div className="border mb-1 hover-shadow d-flex justify-content-center align-items-center"><img style={{width:'100%'}} src={formData?.featured_image}  alt="" /></div>}

          <ImageUpload setImage={(e) => handleInputChange('featured_image',e)} />

          {/* <Form.Group controlId="formLandingCardFeaturedImage" className="mb-3">
            <Form.Label>Featured Image URL</Form.Label>
            <Form.Control
              type="text"
              value={featuredImage}
              onChange={(e) => setFeaturedImage(e.target.value)}
              placeholder="Enter featured image URL"
              required
            />
          </Form.Group> */}
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ?  (cardId ? 'Updating...' : 'Creating...') : (cardId ? 'Update Landing Card' : 'Create Landing Card') }
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateLandingCardModal;
